// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * store how far a video has been watched by a user
 */
export interface VideoProgressOutput {
  watchedSeconds: unknown;
  totalSeconds: unknown;
}
